import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Supervisor module landing page.
 *
 * Owner (2026-10-05/06): the department pages show MODULES, one card per module, the
 * same cards as the Workflows catalog (DeptLandingSections); a card shows only when the
 * person may open it. The approvals live inside their modules (Personal Attendance, EPO,
 * Travel). No "coming soon" note. The route is gated by dept.supervisor in allRoutes.js.
 */
const MODULES = ["pac", "epo", "travel", "tasks", "project", "time", "orgchart", "kpi"];

const Supervisor = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-user-settings-line"
                        eyebrow="Oversight"
                        title="Supervisor"
                        subtitle="Team oversight and approvals"
                        tone="violet"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Supervisor" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="all" title="Supervisor modules" icon="ri-inbox-archive-line" />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Supervisor;
